// import { nodeRestApi } from '../../plugins/api';

// export default {
//   //setting userData
//   setUserData: (state, user) => {
//     state.user = user;
//     localStorage.setItem('user', JSON.stringify(user));
//     nodeRestApi.defaults.headers.common[
//       'Autherization'
//     ] = `Bearer ${user.token}`;
//   },

//   clearUserData: state => {
//     localStorage.removeItem('user');
//     location.reload();
//   }
// };

import { setToken } from '../../plugins/api';

export default {
  setUserData: (state, user) => {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
    setToken(user.token); // login ke baad token set karo
  },

  clearUserData: state => {
    localStorage.removeItem('user');
    location.reload();
  }
};
